export const ServerBaseUrl =
  process.env.REACT_APP_SERVER_BASE_URL || "https://api.amoozical.com/api/v1";

export const ServerRoutes = {
  login: `${ServerBaseUrl}/admin/auth/login`,
  users: `${ServerBaseUrl}/admin/users`,
  userTree: `${ServerBaseUrl}/admin/user`,
  bd: `${ServerBaseUrl}/admin/bd`,
  // Referrals: users ordered by referral count (list page).
  referrals: `${ServerBaseUrl}/admin/users/by-referrals`,
  saleReport: `${ServerBaseUrl}/admin/sale-report`,
  saleTransactions: `${ServerBaseUrl}/admin/transactions/sale`,
  stats: `${ServerBaseUrl}/admin/stats`,
  communitySale: `${ServerBaseUrl}/admin/community-sales-volumes`,
  subscriptions: `${ServerBaseUrl}/admin/subscriptions`,
  courses: `${ServerBaseUrl}/admin/courses`,
  dashboardSummary: `${ServerBaseUrl}/admin/dashboard/summary`,
  courseWatchProgress: `${ServerBaseUrl}/admin/dashboard/watch-progress`,
  courseSeasons: `${ServerBaseUrl}/admin/course-seasons`,
  courseItems: `${ServerBaseUrl}/admin/course-items`,
  UsersStats: `${ServerBaseUrl}/admin/users/stats`,
  liveIndicator: `${ServerBaseUrl}/admin/live-indicator`,
  campaigns: `${ServerBaseUrl}/admin/campaigns`,
  campaignStats: `${ServerBaseUrl}/admin/campaigns/stats`,
};

export const TelegramBotUsername =
  process.env.REACT_APP_TELEGRAM_BOT || "amoozicalbot";
